import { primary, R500 } from '@assets/colors';
import { thousandSeparator } from '@ajaibid/utils';

export const TYPE_BUY = 'TYPE_BUY_STOCK';
export const TYPE_SELL = 'TYPE_SELL_STOCK';
export const TYPE_SELL_BONUS = 'TYPE_SELL_BONUS_STOCK';
export const DEFAULT_MESSAGE = 'Order Sent.';

// FORM ID
export const INPUT_PRICE = 'INPUT_PRICE';
export const INPUT_LOT = 'INPUT_LOT';
export const INPUT_PRICE_AUTO = 'INPUT_PRICE_AUTO';
export const INPUT_LOT_AUTO = 'INPUT_LOT_AUTO';
export const INPUT_PRICE_AUTO_LIMIT = 'INPUT_PRICE_AUTO_LIMIT';
export const INPUT_START_DATE = 'INPUT_START_DATE';
export const INPUT_END_DATE = 'INPUT_END_DATE';

// OPTIONS FOR SELECT
export const ACCOUNT_TYPE_OPTIONS = [
  {
    value: 'margin',
    text: 'Margin Trading',
  },
  {
    value: 'regular',
    text: 'Regular',
  },
];

export const ORDER_PERIOD_OPTIONS = [
  {
    value: 'day',
    text: 'Hari',
    description: 'Order aktif sepanjang hari bursa yang sama',
  },
  {
    value: 'session',
    text: 'Sesi',
    description: 'Order aktif hanya sampai sesi perdagangan yang dipilih berakhir',
  },
];

export const PERCENTAGE = [
  {
    value: 0.25,
    label: '25%',
  },
  {
    value: 0.5,
    label: '50%',
  },
  {
    value: 0.75,
    label: '75%',
  },
  {
    value: 1,
    label: '100%',
  },
];

export const INITIAL_FORM_VALUES = (stockPrice) => ({
  [INPUT_PRICE]: {
    initialValue: '0',
    value: thousandSeparator(stockPrice),
    error: false,
  },
  [INPUT_LOT]: {
    initialValue: '1',
    value: '1',
    error: false,
  },
  [INPUT_PRICE_AUTO_LIMIT]: {
    initialValue: '0',
    value: thousandSeparator(stockPrice),
    error: false,
  },
  [INPUT_PRICE_AUTO]: {
    initialValue: '0',
    value: thousandSeparator(stockPrice),
    error: false,
  },
  [INPUT_LOT_AUTO]: {
    initialValue: '1',
    value: '1',
    error: false,
  },
});

export const configOrder = {
  [TYPE_BUY]: {
    btnVariant: 'primary',
    btnWording: 'Beli',
    autoWording: 'Buy',
    color: primary,
  },
  [TYPE_SELL]: {
    btnVariant: 'danger',
    btnWording: 'Jual',
    autoWording: 'Sell',
    color: R500,
  },
  [TYPE_SELL_BONUS]: {
    btnVariant: 'danger',
    btnWording: 'Jual Saham Bonus',
    autoWording: 'Sell',
    color: R500,
  },
};

export const wording = {
  periode: {
    [ORDER_PERIOD_OPTIONS[0].value]: [ORDER_PERIOD_OPTIONS[0].text],
    [ORDER_PERIOD_OPTIONS[1].value]: [ORDER_PERIOD_OPTIONS[1].text],
  },
  akun: {
    [ACCOUNT_TYPE_OPTIONS[0].value]: [ACCOUNT_TYPE_OPTIONS[0].text],
    [ACCOUNT_TYPE_OPTIONS[1].value]: [ACCOUNT_TYPE_OPTIONS[1].text],
  },
  variant: {
    [TYPE_BUY]: 'primary',
    [TYPE_SELL]: 'danger',
    [TYPE_SELL_BONUS]: 'danger',
  },
};
